import moment from 'moment';

import { validateRequired } from '../../../../utils/validations';
export const GREATER_OR_EQUAL_THAN_ZERO_MESSAGE =
  'Value must be greater than or equal to zero';

const validate = (values: Object) => {
  const errors = {};

  ['squareFeet', 'startDate'].forEach((fieldName) => {
    if (!validateRequired(fieldName, values)) {
      errors[fieldName] = 'Required';
    }
  });

  if (isNaN(+values.squareFeet) || +values.squareFeet < 0) {
    errors.squareFeet = GREATER_OR_EQUAL_THAN_ZERO_MESSAGE;
  }

  if (values.startDate) {
    const startDate = moment(values.startDate);
    if (!startDate.isValid()) {
      errors.startDate = 'Invalid date.';
    }
  }

  return errors;
};

export default validate;
